import React from 'react';
import { Heart, AlertTriangle, Activity, Zap } from 'lucide-react';
import { Card, CardContent } from '../../../components/ui/card';

const ReputationInsights = ({ health, risk, engagement, activityLevel }) => {
  const getHealthColor = (health) => {
    switch (health) {
      case 'Excellent': return '#10B981';
      case 'Good': return '#00B4D8';
      case 'Fair': return '#F59E0B';
      case 'Poor': return '#EF4444';
      case 'Critical': return '#DC2626';
      default: return '#6C757D';
    }
  };

  const getRiskColor = (risk) => {
    switch (risk) {
      case 'Low': return '#10B981';
      case 'Medium': return '#F59E0B';
      case 'High': return '#EF4444';
      case 'Critical': return '#DC2626';
      default: return '#6C757D';
    }
  };

  const getEngagementColor = (engagement) => {
    switch (engagement) {
      case 'High': return '#10B981';
      case 'Medium': return '#00B4D8';
      case 'Low': return '#EF4444';
      default: return '#6C757D';
    }
  };

  const getActivityColor = (activity) => {
    if (activity === 'Very Active' || activity === 'Active') return '#10B981';
    if (activity === 'Moderate') return '#00B4D8';
    if (activity === 'Low') return '#F59E0B';
    return '#EF4444';
  };

  const insights = [
    {
      label: 'Health',
      value: health || 'Unknown',
      icon: Heart,
      color: getHealthColor(health)
    },
    {
      label: 'Risk Level',
      value: risk || 'Unknown',
      icon: AlertTriangle,
      color: getRiskColor(risk)
    },
    {
      label: 'Engagement',
      value: engagement || 'Unknown',
      icon: Zap,
      color: getEngagementColor(engagement)
    },
    {
      label: 'Activity Level',
      value: activityLevel || 'Unknown',
      icon: Activity,
      color: getActivityColor(activityLevel)
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {insights.map((insight) => {
        const Icon = insight.icon;
        return (
          <Card key={insight.label} className="hover:shadow-md transition-shadow">
            <CardContent className="pt-6">
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <p className="text-sm text-[#6C757D] mb-1">{insight.label}</p>
                  <p 
                    className="text-2xl font-bold"
                    style={{ color: insight.color }}
                  >
                    {insight.value}
                  </p>
                </div>
                <div 
                  className="p-3 rounded-lg"
                  style={{ backgroundColor: `${insight.color}15` }}
                >
                  <Icon className="h-6 w-6" style={{ color: insight.color }} />
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default ReputationInsights;
